import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-draggable-chip-suffix',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./draggable-chip-suffix.component.scss'],
})
export class DraggableChipSuffixComponent {}
